<template>
  <a-modal :title='record.id?"受试者信息":"受试者注册"' :width="width" :visible="visible" :confirmLoading="confirmLoading" @cancel="handleCancel"
    class="my-form">
    <!--horizontal  vertical-->
    <a-form-model layout="vertical" :model="record" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules"
      ref="form">
      <a-row>
        <a-col :span="9">
          <a-form-model-item v-if="record.id" label="受试者编号">
            {{ record.patientNum ? record.patientNum : '系统生成' }}
          </a-form-model-item>
        </a-col>
        <a-col :span="9">
          <!-- <a-form-model-item v-if="1==2" label="EID">
            {{ record.eid }} <a-button type="link"
              :style="`margin-left: ${record.eid === undefined ? '0' : '20px'};padding: 0`">关联EID</a-button>
          </a-form-model-item> -->
        </a-col>
        <a-col :span="6" v-if="record.id" v-has="'patient:wxjcode'" >
          <a-form-model-item label="奖励码" help="可用于奖励受试者，发放红包。">
            <template v-if="record.wjxCode">
              已绑定
              <span v-if="wjxCodeEdit">
                <a-input style="width: 180px" placeholder="请输入" v-model="currentWjxCode" />
                <a-button type="link" @click="setWjxCode2(record.id, currentWjxCode)">保存</a-button>
                <a-button type="link" @click="wjxCodeEdit = false">取消</a-button>
              </span>
              <span v-else>{{ record.wjxCode }}<a-button v-if="!isView" style="margin-left: 10px" type="link"
                  @click="handleWjxCodeEdit">手动修改奖励码</a-button></span>
            </template>
            <a-button :loading="wjxCodeLoading" v-if="!record.wjxCode && !isView" type="link"
              @click="setWjxCode(record.id)">自动关联奖励码</a-button>
          </a-form-model-item>
        </a-col>
        <a-col :span="6" v-else></a-col>
        <a-col :span="9">
          <a-form-model-item label="受试者姓名" prop="name">
            <a-input :disabled="isView" placeholder="请输入受试者姓名" v-model="record.name" />
          </a-form-model-item>
        </a-col>
       <a-col :span="9">
          <a-form-model-item label="身份证号" prop="idcard">
            <div style="display: flex; gap: 8px;">
              <a-input :disabled="isView" placeholder="请输入身份证号" v-model="record.idcard" @blur="idcardBlur" />
              <j-camera-capture  @data-update="handleDataUpdate" v-has="'patient:idcard'"></j-camera-capture>
            </div>
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="6"></a-col> -->
        <a-col :span="9" prop="birthDay">
          <a-form-model-item label="出生日期">
            <a-date-picker :disabled="!!record.idcard || isView" style="width: 100%" placeholder="请选择出生日期"
              valueFormat="YYYY-MM-DD" allowClear v-model="record.birthDay" />
          </a-form-model-item>
        </a-col>
        <a-col :span="9">
          <a-form-model-item label="年龄" prop="age">
            <a-input-number v-model="record.age" :disabled="!!record.idcard || isView" :min="0" :max="130"
              placeholder="请输入年龄" :precision="0" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-model="record.sex" button-style="solid" :disabled="!!record.idcard || isView">
              <a-radio-button value="1">
                男
              </a-radio-button>
              <a-radio-button value="0">
                女
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="19">
          <a-form-model-item label="备注" prop="description">
            <a-textarea :disabled="isView" placeholder="请输入备注" :rows="2" v-model="record.description" />
          </a-form-model-item>
        </a-col>
        <a-col :span="5"></a-col>

        <template v-for="(field, index) in fieldList">
          <a-col :span="12" v-if="field.type === '2'" :key="index">
            <a-form-model-item :label="field.name" :prop="`defineField[${field.id}]`">
              <a-input :disabled="isView" v-if="field.input === '1'" :placeholder="`请输入${field.name}`"
                v-model="record.defineField[field.id]" />
              <a-input-number :disabled="isView" v-if="field.input === '2'" :placeholder="`请输入${field.name}`"
                v-model="record.defineField[field.id]" :precision="2" style="width: 100%" />
              <a-date-picker :disabled="isView" v-if="field.input === '3'" style="width: 100%"
                :placeholder="`请选择${field.name}`" valueFormat="YYYY-MM-DD HH:mm:ss" allowClear
                v-model="record.defineField[field.id]" />
              <a-select :disabled="isView" v-if="field.input === '4'" v-model="record.defineField[field.id]" allowClear
                placeholder="请选择">
                <a-select-option :value="item.value" v-for="(item, ii) in getSelectData(field.selectData)"
                  :key="ii">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </template>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item label="联系人1" prop="telephone1" style="color:red">
            <a-select :disabled="isView" v-model="record.teleType1" allowClear placeholder="请选择">
              <a-select-option :value="item.value" v-for="(item, index) in teleTypeList"
                :key="index">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
         
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="联系电话1" prop="telephone1">
            <a-input :disabled="isView" placeholder="请输入联系电话号码1" v-model="record.telephone1" style="width: 100%" />
          </a-form-model-item>
        </a-col>
         <a-col :span="12">
          <a-form-model-item label="联系人2" prop="telephone2" style="color:red">
            <a-select :disabled="isView" v-model="record.teleType2" allowClear placeholder="请选择">
              <a-select-option :value="item.value" v-for="(item, index) in teleTypeList"
                :key="index">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
         
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="联系电话2" prop="telephone2">
            <a-input :disabled="isView" placeholder="请输入联系电话号码2" v-model="record.telephone2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
         <a-col :span="12">
          <a-form-model-item label="联系人3" prop="telephone3" style="color:red">
            <a-select :disabled="isView" v-model="record.teleType3" allowClear placeholder="请选择">
              <a-select-option :value="item.value" v-for="(item, index) in teleTypeList"
                :key="index">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
         
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="联系电话3" prop="telephone2">
            <a-input :disabled="isView" placeholder="请输入联系电话号码3" v-model="record.telephone3" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <!-- <a-col :span="8">
          <a-form-model-item label="联系方式2">
            <a-select :disabled="isView" v-model="record.teleType2" allowClear placeholder="请选择">
              <a-select-option :value="item.value" v-for="(item, index) in teleTypeList"
                :key="index">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="" prop="telephone2">
            <a-input :disabled="isView" placeholder="请输入联系号码2" v-model="record.telephone2" style="width: 100%" />
          </a-form-model-item>
        </a-col> -->
        <!-- <a-col :span="8">
          <a-form-model-item label="联系方式3">
            <a-select :disabled="isView" v-model="record.teleType3" allowClear placeholder="请选择">
              <a-select-option :value="item.value" v-for="(item, index) in teleTypeList"
                :key="index">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="" prop="telephone3">
            <a-input :disabled="isView" placeholder="请输入联系号码3" v-model="record.telephone3" style="width: 100%" />
          </a-form-model-item>
        </a-col> -->
      </a-row>
      <a-row v-if="record.id">
        <a-col :span="24">
          <a-form-model-item label="患者知情同意书">
            <a-switch :disabled="isView" v-model="record.processBl" />上传纸质版
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="record.processBl">
          <a-form-model-item>
            <j-image-upload class="avatar-uploader" :is-multiple="true" text="上传" v-model="fileList"
              :bizPath="`${record.projectId}/patient/process`" :disabled="isView"> </j-image-upload>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="templates.length>0">
          <a-form-model-item v-for="(item, index) in templates" :key="index">
            <a-icon type="plus" /> <a href="javascript:;" :disabled="isView" @click="check(item.id)">电子版({{item.name}})</a> <a-icon v-if="item.isExistSign" type="edit" />         
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template slot="footer">
      <div v-if="!isView">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleSubmit">
          保存
        </a-button>
      </div>
      <div v-else>

      </div>
    </template>

  </a-modal>
</template>

<script>
import JImageUpload from '@/components/jeecg/JImageUpload'
import JCameraCapture from '@/components/jeecg/JCameraCapture'
import baseRules from '@/constants/baseRules'
import { checkID } from '@/constants/baseRules'
import { idcardInfo } from '@/utils/patientInput'
import { postAction, getAction } from '@/api/manage'

import idcardArea from '@/utils/id_card_area'
export default {
  name: 'PatientEdit',
  components: { JImageUpload,JCameraCapture },
  props: {
    fieldList: {
      type: Array,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '60%'
    }
  },
  data() {
    return {
      selectedFile: null,
      resultUrl: null,
      ocrText: [],
      labelCol: { span: 24 },
      wrapperCol: { span: 22 },
      record: {
        defineField: {}
      },
      confirmLoading: false,
      visible: false,
      teleTypeList: [
        { value: '1', text: '本人' },
        { value: '2', text: '配偶' },
        { value: '3', text: '子女' },
        { value: '4', text: '父母' },
        { value: '5', text: '朋友' },
        { value: '6', text: '其他亲戚' },
        { value: '9', text: '其他' },
      ],
      rules: {
        idcard: [baseRules.idcard],
        defineField: {},
        telephone1: [baseRules.phone],
        telephone2: [baseRules.phone],
        telephone3: [baseRules.phone],
      },
      fileList: [],
      isView: false,
      wjxCodeLoading: false,
      wjxCodeEdit: false,
      currentWjxCode: '',
      isExistModel:false,
      cameraVisible: false,
      photoData: null,
      uploadVisible: false,
      templates: [],
    }
  },
  watch: {
    fieldList() {
      this.initRules()
    }
  },
  mounted() {
    this.initRules()
  },
  methods: {
   handleDataUpdate(data) {
      this.$set(this.record, 'idcard', data.idCard);
      this.$set(this.record, 'name', data.name);
      this.idcardBlur()
    },
    
    async getDocumentData(id) {
      const res = await getAction('/patient/patientInformedConsentForm/queryTemplateByPatientId', { patientId: id })
      if (res.success && res.result != null) {
        this.templates = res.result
        this.isExistModel=true
      }else{
        this.isExistModel=false
      }
    },
    check(templateId) {
      this.visible = false;
      this.$emit('toggleConsentForm', {flag: true, templateId: templateId})
    },
    handleWjxCodeEdit() {
      this.currentWjxCode = this.record.wjxCode
      this.wjxCodeEdit = true
    },
    setWjxCode(id) {
      this.wjxCodeLoading = true
      postAction('/patient/patient/setWjxCode', { id: id, wjxCode: this.currentWjxCode }).then(res => {
        if (res.success) {
          this.$set(this.record, 'wjxCode', res.result);
        }
      }).finally(() => {
        this.wjxCodeLoading = false
      })
    },
    setWjxCode2() {
      if (!this.currentWjxCode) {
        return this.$message.warning('请输入奖励码')
      }
      this.record.wjxCode = this.currentWjxCode
      this.wjxCodeEdit = false
    },
    idcardBlur() {
      if (this.record.idcard && checkID(this.record.idcard)) {
        this.$set(this.record, 'birthDay', idcardInfo(this.record.idcard, 1))
        this.$set(this.record, 'sex', idcardInfo(this.record.idcard, 2))
        this.$set(this.record, 'age', idcardInfo(this.record.idcard, 3))
        // this.$set(this.record,'description',idcardArea.getAreaByIdCard(this.record.idcard))

      }
    },
    initRules() {
      const rules = this.rules
      this.fieldList.forEach(field => {
        // 受试者自定义属性
        if (field.type === '2') {
          if (!rules[field.id]) {
            const itemRules = []
            if (field.required === '1') {
              if (field.input === '1' || field.input === '2') {
                itemRules.push(baseRules.required)
                if (field.input === '1') {
                  if (field.checkType) {
                    itemRules.push(baseRules[field.checkType])
                  }
                  if (field.minLength) {
                    itemRules.push(
                      {
                        validator: (rule, value, callback) => {
                          if (value) {
                            if (value.length < field.minLength) {
                              callback('长度最小为' + field.minLength);
                              return
                            }
                          }
                          callback();
                        }, trigger: 'blur'
                      }
                    )
                  }
                  if (field.maxLength) {
                    itemRules.push(
                      {
                        validator: (rule, value, callback) => {
                          if (value) {
                            if (value.length > field.maxLength) {
                              callback('长度最大为' + field.maxLength);
                              return
                            }
                          }
                          callback();
                        }, trigger: 'blur'
                      }
                    )
                  }
                }
              } else {
                itemRules.push(baseRules.requiredChange)
              }
            }
            rules.defineField[field.id] = itemRules
          }
        } else {
          // 固定属性
          if (field.required === '1') {
            field.fieldName.split(',').forEach(fieldName => {
              let rulesArray = rules[fieldName] || []
              if (fieldName === 'sex' || fieldName.indexOf('teleType') > 0) {
                rulesArray.push(baseRules.requiredChange)
              } else {
                rulesArray.push(baseRules.required)
              }
              rules[fieldName] = rulesArray
            })
          }

        }
      })
      this.rules = rules

    },
    view(record) {
      this.isView = true
      this.initRecord(record);
    },
    edit(record) {
      this.isView = false
      this.initRecord(record);
    },
    initRecord(record) {
      record.defineField = record.defineField || {}
      record.processBl = record.process === '1'
      this.fileList = record.processFile
      if (record.fieldValueList) {
        record.fieldValueList.forEach(item => {
          record.defineField[item.fieldId] = item.value
        })
      }
      this.record = JSON.parse(JSON.stringify(record))
      this.visible = true
      this.getDocumentData(this.record.id)
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit() {
      if (this.isView) {
        this.handleCancel()
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.record.process = this.record.processBl ? '1' : '0'
          this.record.processFile = this.fileList
          const fieldValueList = []
          if (this.record.defineField) {
            for (let key in this.record.defineField) {
              const fs = this.fieldList.filter(f => f.id === key)
              if (fs && fs.length > 0) {
                fieldValueList.push({
                  value: this.record.defineField[key],
                  baseFieldName: fs[0].name,
                  fieldId: key
                })
              }
            }
          }

          if ((this.record.teleType1 && !this.record.telephone1) || !this.record.teleType1 && this.record.telephone1) {
            return this.$message.warning('请输入完整的联系方式1')
          }
          if ((this.record.teleType2 && !this.record.telephone2) || !this.record.teleType2 && this.record.telephone2) {
            return this.$message.warning('请输入完整的联系方式2')
          }
          if ((this.record.teleType3 && !this.record.telephone3) || !this.record.teleType3 && this.record.telephone3) {
            return this.$message.warning('请输入完整的联系方式3')
          }
          if (this.record.wjxCode && this.record.wjxCode.length != 20) {
            return this.$message.warning('请输入长度为20的随机码')
          }
          this.confirmLoading = true
          // 校验是否二次入组
          // 校验二次入组
          postAction('/patient/patient/checkAgain', this.record,30000).then(res => {
            console.log(res)
            if (res.success && res.result && res.result.count > 0) {
              if(res.result.repeatRule == 0){ //提醒重复入组
                this.$confirm({
                  title: '再次入组',
                  content: '当前患者是再次入组！是否保存？',
                  onOk: () => {
                    this.submitAction()
                  },
                  onCancel: () => {
                    this.confirmLoading = false
                  }
                });
              }else if(res.result.repeatRule == 1){ //禁止重复入组
                this.$message.warning('当前患者已经入组，不允许重复入组！')
                this.confirmLoading = false
              }
            } else {
              this.submitAction()
            }
          }).catch((error) => {
            this.confirmLoading = false
          })
          .finally(() => {
            // this.confirmLoading = false
          })
        } else {
        }
      })

    },
    submitAction() {
      this.confirmLoading = true
      postAction('/patient/patient/registerOrUpdate', this.record,10000).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          if (this.record.id) {
            this.$emit('loadOne')
          } else {
            this.$emit('ok')
          }
          this.handleCancel()
          // if(this.record.id){
          //   this.$confirm({
          //     title: '是否继续注册',
          //     content: '注册成功！是否继续注册受试者？',
          //     onOk:()=> {
          //       this.edit({projectId:this.record.projectId})
          //     },
          //     onCancel:()=> {
          //       this.handleCancel()
          //     },
          //   });
          // }else{
          //   this.handleCancel()
          // }
        }else{
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    getSelectData(json) {
      try {
        return JSON.parse(json)
      } catch (e) {
        return []
      }
    }
  }
}
</script>

<style scoped lang="less">
.center-container {
  display: flex;
  justify-content: center;
}
.my-form {
  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-modal-content {
    background-color: #f5f6fa;
  }

  /deep/ .ant-modal-header {
    background-color: #f5f6fa;
  }

  /deep/ .ant-input {
    border-radius: 12px;
  }

  /deep/ .ant-select-selection {
    border-radius: 12px;
  }

  /deep/ .ant-input-number {
    border-radius: 12px;
  }
}
</style>